import { useEffect, useRef } from "react";

import { ManualOrderPanel } from "./manual-order-panel.js";

export function ManualOrderDialog({
  symbol,
  open,
  onClose,
}: {
  readonly symbol: string;
  readonly open: boolean;
  readonly onClose: () => void;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog === null) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);
  return (
    <dialog
      aria-label={`Create ${symbol} order`}
      className="manual-order-dialog"
      onClose={onClose}
      ref={dialogRef}
    >
      <div className="manual-order-dialog__top">
        <strong>Create {symbol} order</strong>
        <button className="button button--quiet" onClick={onClose} type="button">
          Close
        </button>
      </div>
      <p className="field-hint">
        Closing this window does not cancel a submitted order. Reopen it to check the latest status.
      </p>
      <ManualOrderPanel symbol={symbol} />
    </dialog>
  );
}
